@if (status() === 'none') {
<div class="ac-flex ac-flex-ctr ac-flex-col ac-gap-lg">
  <ng-content select="[kyc-hero]"></ng-content>
  <button
    mat-flat-button
    (click)="startVerification(); $event.preventDefault()"
    [loading]="loading()"
    [class.ac-btn-lg]="largeButtons()"
    [style.width.%]="fullWidthButtons() ? 100 : null"
  >
    Continue
  </button>
</div>
} @else { @switch (status()) { @case('approved') {
<div class="ac-flex ac-flex-col ac-gap-lg ac-ctr">
  <app-lottie-animation [size]="132" path="payments_complete" [loop]="false" />
</div>
} @case ('rejected') {
<div class="ac-flex ac-flex-col ac-gap-lg ac-ctr">
  <ac-icon iconKey="payment:fail" [size]="132" />

  <button
    mat-flat-button
    (click)="startVerification(true); $event.preventDefault()"
    [style.width.%]="fullWidthButtons() ? 100 : null"
    [class.ac-btn-lg]="largeButtons()"
    [loading]="loading()"
  >
    Try again
  </button>

  <button
    mat-flat-button
    (click)="verifyLater.emit(); $event.preventDefault()"
    [style.width.%]="fullWidthButtons() ? 100 : null"
    [class.ac-btn-lg]="largeButtons()"
    class="ac-secondary"
  >
    I'll verify another time
  </button>
</div>
} @default {
<div class="ac-flex ac-flex-col ac-gap-lg ac-ctr">
  <app-lottie-animation [size]="132" path="payments_pending" />
</div>
} } }
